webpackJsonp([213534597649335],{

/***/ 40:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(15);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostPreview = function PostPreview(props) {
	  var _classnames;
	
	  var postPreviewClass = (0, _classnames3.default)((_classnames = {
	    post: true
	  }, _classnames['post--' + props.size] = props.size, _classnames['post--succinct'] = props.succinct, _classnames));
	
	  return _react2.default.createElement(
	    'div',
	    { className: postPreviewClass },
	    _react2.default.createElement(
	      _Link2.default,
	      { className: 'post__link', to: props.path },
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'post__content-preview' },
	        props.excerpt
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'post__meta' },
	        props.author,
	        ' \xB7 ',
	        props.date
	      )
	    )
	  );
	};
	
	PostPreview.propTypes = {
	  size: _propTypes2.default.string,
	  succinct: _propTypes2.default.bool,
	  title: _propTypes2.default.string.isRequired,
	  excerpt: _propTypes2.default.string.isRequired,
	  author: _propTypes2.default.string,
	  date: _propTypes2.default.string,
	  path: _propTypes2.default.string.isRequired
	};
	
	PostPreview.defaultProps = {
	  size: '',
	  succinct: false,
	  author: '',
	  date: ''
	};
	
	exports.default = PostPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PostPreview = __webpack_require__(31);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PostPreview2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Tag = __webpack_require__(33);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	__webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'section' },
	    _react2.default.createElement(
	      'h5',
	      { className: 'section__title' },
	      _react2.default.createElement(
	        _Link2.default,
	        { to: props.to || '' },
	        props.title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section__body' },
	      props.children
	    )
	  );
	};
	
	var Sidebar = function Sidebar(_ref) {
	  var featuredTags = _ref.featuredTags,
	      userInformation = _ref.userInformation,
	      snsLink = _ref.snsLink,
	      friends = _ref.friends;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('link', {
	        rel: 'stylesheet',
	        href: 'https://cdn.bootcss.com/font-awesome/4.7.0/css/font-awesome.min.css'
	      })
	    ),
	    _react2.default.createElement(
	      Section,
	      { title: 'FEATURED TAGS', to: '/tags' },
	      _react2.default.createElement(
	        'div',
	        { className: 'featured-tags' },
	        featuredTags.map(function (item, index) {
	          return _react2.default.createElement(
	            _Tag2.default,
	            { key: item + '-' + index, to: '/tags#' + item },
	            item
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      { title: 'ABOUT ME', to: '/about' },
	      _react2.default.createElement(
	        'div',
	        { className: 'short-about' },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/about' },
	          _react2.default.createElement('img', {
	            className: 'short-about__avatar rounded',
	            src: userInformation.avatar
	          })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'short-about__intro' },
	          userInformation.bio
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'styles.sns list-inline' },
	          snsLink.map(function (item, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: item + '-' + index, className: 'list-inline-item' },
	              _react2.default.createElement(
	                'a',
	                { className: 'sns__link', target: '_blank', href: item.to },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'fa-stack fa-lg' },
	                  _react2.default.createElement('i', { className: 'fa fa-circle fa-stack-2x' }),
	                  item.icon ? _react2.default.createElement('i', {
	                    className: 'fa fa-' + item.icon + ' fa-stack-1x fa-inverse'
	                  }) : _react2.default.createElement(
	                    'i',
	                    { className: 'fa fa-stack-1x fa-inverse' },
	                    item.text
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      { title: 'FRIENDS' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'friend-links list-inline' },
	        friends.map(function (item, index) {
	          return _react2.default.createElement(
	            'li',
	            { key: item + '-' + index, className: 'list-inline-item' },
	            _react2.default.createElement(
	              'a',
	              { className: 'friend-links__link', href: item.to, target: '_blank' },
	              item.name
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	Sidebar.propTypes = {
	  featuredTags: _propTypes2.default.array.isRequired,
	  userInformation: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    bio: _propTypes2.default.string.isRequired,
	    avatar: _propTypes2.default.string.isRequired
	  }).isRequired,
	  snsLink: _propTypes2.default.array.isRequired,
	  friends: _propTypes2.default.array.isRequired
	};
	
	exports.default = Sidebar;
	module.exports = exports['default'];

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Sidebar = __webpack_require__(62);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Header = __webpack_require__(43);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PostPreview = __webpack_require__(32);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	var _Sidebar = __webpack_require__(63);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pagination = function Pagination(_ref) {
	  var page = _ref.page,
	      totalPage = _ref.totalPage;
	
	  var hasPrevPage = page > 1;
	  var hasNextPage = page < totalPage;
	
	  if (!hasPrevPage && !hasNextPage) return null;
	
	  var prevBtnClass = (0, _classnames2.default)({
	    'page-item': true,
	    disabled: !hasPrevPage
	  });
	
	  var nextBtnClass = (0, _classnames2.default)({
	    'page-item': true,
	    disabled: !hasNextPage
	  });
	
	  return _react2.default.createElement(
	    'nav',
	    { className: 'mt-4' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'pagination justify-content-end' },
	      _react2.default.createElement(
	        'li',
	        { className: prevBtnClass },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'page-link',
	            to: hasPrevPage ? '/pages/' + (page - 1) : null,
	            style: { color: '#a3a3a3' }
	          },
	          'Previous'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: nextBtnClass },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'page-link',
	            to: hasNextPage ? '/pages/' + (page + 1) : null,
	            style: { color: '#a3a3a3' }
	          },
	          'Next'
	        )
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage(props) {
	  var allMarkdownRemark = props.data.allMarkdownRemark;
	
	
	  if (!allMarkdownRemark) return null;
	
	  var siteMetadata = props.data.site.siteMetadata;
	
	  var edges = props.pathContext.posts || allMarkdownRemark.edges.slice(0, 10);
	
	  var Posts = edges.map(function (item, index) {
	    return _react2.default.createElement(_PostPreview2.default, {
	      key: item + '-' + index,
	      title: item.node.frontmatter.title,
	      author: siteMetadata.defaultAuthor,
	      date: item.node.frontmatter.date,
	      excerpt: item.node.excerpt,
	      path: '/articles' + item.node.fields.slug
	    });
	  });
	
	  var mappedTags = {};
	
	  allMarkdownRemark.edges.forEach(function (item) {
	    var tags = item.node.frontmatter.tags;
	
	
	    if (!tags) return;
	
	    tags.forEach(function (tag) {
	      if (!mappedTags[tag]) {
	        mappedTags[tag] = 0;
	      }
	
	      mappedTags[tag] += 1;
	    });
	  });
	
	  var featuredTags = Object.keys(mappedTags).filter(function (item) {
	    return mappedTags[item] >= siteMetadata.limitOfFeaturedTags;
	  });
	
	  var totalPage = props.pathContext.totalPage || Math.ceil(allMarkdownRemark.totalCount / 10);
	  var userInformation = {
	    name: siteMetadata.name,
	    bio: siteMetadata.bio,
	    avatar: siteMetadata.avatar
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        siteMetadata.SEOTitle
	      )
	    ),
	    _react2.default.createElement(_Header2.default, {
	      title: siteMetadata.name,
	      description: siteMetadata.bio,
	      bg: siteMetadata.bgOfHomeHeader
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'main-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-9' },
	            Posts,
	            _react2.default.createElement(Pagination, {
	              page: props.pathContext.page || 1,
	              totalPage: totalPage
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3' },
	            _react2.default.createElement(_Sidebar2.default, {
	              featuredTags: featuredTags,
	              userInformation: userInformation,
	              snsLink: siteMetadata.snsLink,
	              friends: siteMetadata.friends
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-71fe515fc9d09c74b252.js